import { create } from 'zustand';

import type { ChatLiveActivity } from '~/shared/agent-chat';

import { agUiBlockActivityType, type UiActionBlock, uiActionBlockSchema } from '../data-contract/chat';

export const MAX_SETTLED_UI_ACTIONS = 200;

const UI_ACTION_ACTIVITY_TYPE = agUiBlockActivityType('ui-action');

type UiActionState = {
    readonly pending: readonly UiActionBlock[];
    readonly settledBlockIds: ReadonlySet<string>;
    readonly offer: (block: UiActionBlock) => void;
    readonly settle: (blockId: string) => void;
};

export const useUiActionStore = create<UiActionState>((set) => ({
    offer: (block) =>
        set((state) => {
            const isKnown =
                state.settledBlockIds.has(block.blockId) ||
                state.pending.some((pending) => pending.blockId === block.blockId);
            return isKnown ? state : { pending: [...state.pending, block] };
        }),
    pending: [],
    settle: (blockId) =>
        set((state) => ({
            pending: state.pending.filter((block) => block.blockId !== blockId),
            settledBlockIds: new Set([...state.settledBlockIds, blockId].slice(-MAX_SETTLED_UI_ACTIONS)),
        })),
    settledBlockIds: new Set(),
}));

export const offerLiveUiAction = (activity: Pick<ChatLiveActivity, 'activityType' | 'content'>): void => {
    if (activity.activityType !== UI_ACTION_ACTIVITY_TYPE) return;
    const parsed = uiActionBlockSchema.safeParse(activity.content);
    if (!parsed.success || !parsed.data.autoRun) return;
    useUiActionStore.getState().offer(parsed.data);
};
